<template>
    <div :style="{ height: `${height}px` }" :id="synopticId"></div>
</template>

<script>
  
    import RLSynoptic from '../vendor/synoptic/runelab-synoptic.esm';
    import _ from "lodash";
    import markerRenderFunction from "../vendor/synoptic/marker-template";

  export default {
    name: "SynopticWidget",
    props: {
      synopticId: {
        type: String
      },
      imageUrl: {
        String
      },
      markerRenderFunction: {
        type: Function,
        default: markerRenderFunction
      },
      markers: {
        type: Array,
        default: function () {
          return []
        }
      },
      options: {
        type: Object
      },
      height: {
        type: Number,
        default: 400
      }
    },
    data: function() {
      return {
        map: undefined
      };
    },
    computed: {},
    watch: {
      'markers': {
        handler: function (newValue) {
          this.onMarkersChanged(newValue);
        },
        deep: true
      },
    },
    methods: {
      initMap: function() {
        const { synopticId, imageUrl, onSynopticClick, onMarkerClick, options, onSynopticLoad } = this;
        this.map = new RLSynoptic(synopticId, options);
        this.map.setBackground(imageUrl);
        this.map.onLoad(onSynopticLoad)
        // if there's no synoptic ID means that this a a synoptic preview (see widgetSummaryStep)
        this.map.setMarkerRenderFunction(markerRenderFunction);
        this.drawMarkers();
        this.map.setMarkersDraggable(true);
        this.map.attachMapClickListener(onSynopticClick);
        this.map.attachMarkerClickListener(onMarkerClick);
      },
      onSynopticClick: function(coordinates) {
        this.$emit('onSynopticClick', coordinates)
      },
      onMarkerClick: function(marker) {
        this.$emit('onMarkerClick', marker)
      },
      onMarkersChanged: function(markers) {
        this.$emit('onMarkerChanged', markers);
        this.map.resetMarkers();
        this.drawMarkers();
      },
      onSynopticLoad: function(e) {
        this.$emit('onSynopticLoad', e)
      },
      drawMarkers: function() {
        const { markers } = this;
        _.each(markers, m => this.map.addMarker(m))
      },
    },
    mounted: function() {
      this.initMap();
    }
  };
</script>

<style lang="scss">
    @import '../vendor/synoptic/runelab-synoptic.esm.css';
</style>
